import Store from 'repatch';

import State from '../core/State';
import setDrawerOpen from '../reducer/setDrawerOpen';

class DrawerOpenUsecase {
  private store: Store<State>;

  constructor({ store }: { store: Store<State> }) {
    this.store = store;
  }

  public setOpen = (open: boolean) => {
    this.store.dispatch(setDrawerOpen(open));
  };
}

export default DrawerOpenUsecase;
